module.exports = __webpack_public_path__ + "img/home_img_07.0c4e265c.png";